import React, { useState, useEffect } from 'react';
import { useLanguage } from './../../store/languageContext';
import { LanguageFactory } from './../../factories';
import GeneralTab from './components/GeneralTab';
import { Tabs } from 'antd';
import EnergyUsage from './components/EnergyUsage';
import WaterUsage from './components/WaterUsage';
import CabonFootprint from './components/CarbonFootPrint'
import RecyclingProgram from './components/RecyclingProgram/Add_Edit'

const { TabPane } = Tabs;

interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any
}

const EnvironmentalImpact = (props: propsTypes) => {

    const { language } = useLanguage()
    const [disabledFlag, setDisabledFlag] = useState<any>(false)
    const lang = new LanguageFactory(language)

    const changeTab = (e: string) => { }

    const disableTabPanes = (value: Boolean) => {
        setDisabledFlag(value)
    }

    return (
        <Tabs defaultActiveKey="1" onChange={changeTab}>
            <TabPane tab={lang.translate(language, 'environmental_impact_tab1')} key="1" disabled={disabledFlag} >
                <GeneralTab isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes} />
            </TabPane>
            <TabPane tab={lang.translate(language, 'environmental_impact_tab2')} key="2" disabled={disabledFlag} >
                <CabonFootprint isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes} />
            </TabPane>
            <TabPane tab={lang.translate(language, 'environmental_impact_tab3')} key="3" disabled={disabledFlag}>
                <EnergyUsage isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes} />
            </TabPane>
            <TabPane tab={lang.translate(language, 'environmental_impact_tab4')} key="4" disabled={disabledFlag}>
                <RecyclingProgram isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes}
                setOperationType={() => false} 
                detailData={{}}/>
            </TabPane>
            <TabPane tab={lang.translate(language, 'environmental_impact_tab5')} key="5" disabled={disabledFlag} >
                <WaterUsage isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes} />
            </TabPane>
        </Tabs>
    )
}

export default EnvironmentalImpact;

